module.exports = __webpack_public_path__ + "i.no2.eefae694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/i.no2.jpg
// module id = /bxh
// module chunks = 0